function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Column, isColumnProperties, PlaceholderContext } from '../../components';
import { getColorsFromBackgroundField } from '../../styles';
import { renderViewModels } from '../../render-view-model';
export default function UiColumn({
  model
}) {
  const {
    blocks = [],
    elementId,
    properties = {},
    background
  } = model.content;

  if (isColumnProperties(properties)) {
    return /*#__PURE__*/React.createElement(Column, _extends({
      id: elementId,
      className: "ui-column"
    }, properties, getColorsFromBackgroundField(background)), /*#__PURE__*/React.createElement(PlaceholderContext.Provider, {
      value: "column"
    }, renderViewModels(blocks)));
  } else {
    throw new Error('TODO: handle case where properties does not pass schema check.');
  }
}